<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="goBack">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Horários dos Professores
          <e-help-tooltip :text="$constants.tooltips.horariosInstrutores.horariosDosInstrutores" />
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="instrutorId"
                  :items="instrutores"
                  item-text="nome"
                  item-value="id"
                  label="Professor(a)"
                  outlined
                  dense
                  clearable
                />
              </v-col>
            </v-row>

            <horario-tabs v-model="tab" class="mb-4" />

            <div v-if="tab === 0">
              <horario-dia-filtro
                v-model="dataSelecionada"
                class="mb-3"
                :disabled="!instrutorId"
                @buscar="buscarDia"
              />

              <horario-lista-agrupada :registros="registrosDia" />
            </div>

            <div v-if="tab === 1">
              <v-btn
                color="primary"
                class="mb-3"
                :disabled="!instrutorId"
                @click="buscarUltimos10Dias"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Atualizar
              </v-btn>
              <horario-lista-agrupada :registros="registrosUltimos10Dias" />
            </div>

            <div v-if="tab === 2">
              <horario-periodo-filtro
                v-model="periodo"
                class="mb-3"
                :disabled="!instrutorId"
                @buscar="buscarPeriodo"
                @gerar-pdf="gerarPdfPeriodo"
              />
              <horario-lista-agrupada :registros="registrosPeriodo" />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <e-modal-espelho-ponto-pdf
      :dialog="dialogPdf"
      :pdf="pdf"
      title="Espelho de Ponto"
      @close="fecharPdf"
    />
  </main-template>
</template>

<script>
const hoje = () => new Date().toISOString().slice(0, 10);

export default {
  name: "InstrutoresHorariosAdminPage",
  data() {
    return {
      tab: 0,
      instrutorId: null,
      instrutores: [],
      dataSelecionada: hoje(),
      periodo: [],
      registrosDia: [],
      registrosUltimos10Dias: {},
      registrosPeriodo: {},
      dialogPdf: false,
      pdf: null,
    };
  },
  watch: {
    instrutorId() {
      this.registrosDia = [];
      this.registrosUltimos10Dias = {};
      this.registrosPeriodo = {};
    },
  },
  mounted() {
    this.carregarInstrutores();
  },
  beforeDestroy() {
    this.limparPdfAtual();
  },
  methods: {
    goBack() {
      this.$goBack();
    },
    async carregarInstrutores() {
      try {
        this.$loaderService.open("Carregando professores");
        this.instrutores = await this.$services.instrutorHorariosService.listarInstrutores();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async buscarDia() {
      if (!this.instrutorId) return;

      try {
        this.$loaderService.open("Carregando horários");
        this.registrosDia = await this.$services.instrutorHorariosService.adminHorariosDia({
          instrutor_id: this.instrutorId,
          data: this.dataSelecionada,
        });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async buscarUltimos10Dias() {
      if (!this.instrutorId) return;

      try {
        this.$loaderService.open("Carregando horários");
        this.registrosUltimos10Dias =
          await this.$services.instrutorHorariosService.adminHorariosUltimos10Dias({
            instrutor_id: this.instrutorId,
          });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async buscarPeriodo(form) {
      if (!this.instrutorId || !form.data_inicio || !form.data_fim) return;
      if (form.data_fim < form.data_inicio) return;

      try {
        this.$loaderService.open("Carregando período");
        this.registrosPeriodo = await this.$services.instrutorHorariosService.adminHorariosPeriodo({
          instrutor_id: this.instrutorId,
          ...form,
        });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async gerarPdfPeriodo(form) {
      if (!this.instrutorId || !form.data_inicio || !form.data_fim) return;
      if (form.data_fim < form.data_inicio) return;

      try {
        this.$loaderService.open("Gerando espelho de ponto");
        this.limparPdfAtual();
        this.pdf = await this.$services.instrutorHorariosService.adminHorariosPeriodoPdf({
          instrutor_id: this.instrutorId,
          ...form,
        });
        this.dialogPdf = true;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    fecharPdf() {
      this.dialogPdf = false;
      this.limparPdfAtual();
    },
    limparPdfAtual() {
      if (this.pdf) {
        window.URL.revokeObjectURL(this.pdf);
        this.pdf = null;
      }
    },
  },
};
</script>
